// eslint-disable-next-line import/prefer-default-export
export const ERROR_TYPES = {
  INVALID_DATA: 'INVALID_DATA',
  NOT_ALLOWED: 'NOT_ALLOWED',
  INVALID_LOGIN: 'INVALID_LOGIN',
  INVALID_TOKEN: 'INVALID_TOKEN',
  INVALID_ROLE: 'INVALID_ROLE',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  EMAIL_ALREADY_USED: 'EMAIL_ALREADY_USED',
  INCORRECT_PASSWORD: 'INCORRECT_PASSWORD',
  EMAIL_ALREADY_VERIFIED: 'EMAIL_ALREADY_VERIFIED',
};
